import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { UiStore } from '@pt/services';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '@hglobal/common';
import { AchievementComponent } from '@pt/components';
import { AchievementStatus, HistoryAchievement } from '@pt/models';
import { environment } from '@pt/environment';

const UNIQUE_ACHIEVEMENT_TEXT = environment.appNameForTransaction;

@Component({
  selector: 'pt-achievement-history, [ptAchievementHistory]',
  templateUrl: './achievement-history.component.html',
  styleUrls: ['./achievement-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconModule, AchievementComponent, DatePipe, NgClass],
})
export class AchievementHistoryComponent {
  readonly uiStore = inject(UiStore);

  achievement = input.required<HistoryAchievement>();

  name = computed(() => {
    const { status, fromUser, toUser, course, unique } = this.achievement();

    return (
      (unique && UNIQUE_ACHIEVEMENT_TEXT)
      || course?.name
      || (status === AchievementStatus.Sent ? toUser?.fullName : fromUser?.fullName)
      || ''
    );
  });
}
